import { html } from "lit";
import { TemplateResult } from "lit-html";
import { customElement } from "lit/decorators.js";
import BaseInput from "./BaseInput";

@customElement("basic-datetime-input")
class BasicDateTimeInput extends BaseInput {

	protected renderInput(): TemplateResult {

		return html`
			<input
				id="${this.id}"
				name="${this.name}"
				type="datetime-local"
				min=${new Date().toISOString().slice(0, 16)}
				value="${this.value || ''}"
			/>
    	`;
	}
}

export default BasicDateTimeInput;